import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const FLOWTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.FlowType.Name')
    .required()
    .maxLength(50)
    .build(),
];

export const FLOWTYPE_CONFIG = {
  entityName: 'FlowType',
  localizationKey: 'Planning::Entity.FlowType',
  fields: FLOWTYPE_FIELDS,
  permission: 'Planning.FlowTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.OperationPlanning + MENU_NAME_SUFFIX,
};
